<template>
  <div class="factory-device-product">
    <el-row class="factory-device-product-title">
      <el-col :span="3">
        <span class="h3">产品库</span>
      </el-col>
      <el-col :span="6" :offset="13">
        <div class="factory-device-product-title-filter">
          <span class="label">产品搜索：</span>
          <el-input placeholder="请输入产品名称" v-model="pagination.name" prefix-icon="el-icon-search"
                    @change="loadSearchProduct"></el-input>
        </div>
      </el-col>
      <el-col :span="2">
        <span class="btn-add" @click="handleProductCreate"> <i class="iconfont icon-tianjia1"></i> 新增产品</span>
      </el-col>
    </el-row>
    <el-row class="factory-device-products" :gutter="20" type="flex">
      <el-col :span="6" v-for="(item, index) in products" :key="index" @click.native="handleProductDetail(item)">
        <div title="查看设备" class="product-item">
          <el-row class="product clearfix">
            <el-col class="product-info" :span="22">
              <p class="info-item">
                <span class="label">产品编号:</span>
                <span class="content">{{item.uuid}}</span>
              </p>
              <p class="info-item">
                <span class="label">产品名称:</span>
                <span class="content product-name">{{item.name}}</span>
              </p>
              <p class="info-item">
                <span class="label">产品备注:</span>
                <span class="content">{{item.remark}}</span>
              </p>
              <p class="info-item">
                <span class="label">已注册设备:</span>
                <span class="content">{{item.deviceNumber | I1000}}</span>
              </p>
            </el-col>
            <el-col class="operate" :span="2">
              <div class="publish" title="更多信息"><i class="iconfont icon-gengduo"></i></div>
              <div class="publish" title="删除产品" v-if="item.deviceNumber === 0"
                   @click="handleProductDelete(item.uuid, index)" @click.stop.prevent>
                <i class="iconfont icon-shanchu" ></i>
              </div>
              <div class="publish" title="查看密钥" @click="getProductSecret(item)" @click.stop.prevent>
                <i class="iconfont icon-icon-view"></i>
              </div>

            </el-col>
          </el-row>
          <p class="info-item">
            <span class="label">Key:</span>
            <span class="content">{{item.productKey}}</span>
          </p>
          <p class="info-item">
            <span class="label">密钥:</span>
            <span class="content">{{item.productSecret}}</span>
          </p>
        </div>
      </el-col>
    </el-row>
    <el-pagination
      @current-change="handleCurrentChange"
      class="pagination"
      :current-page="pagination.curPage"
      :page-size="pagination.limit"
      layout="total, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>
    <add-product v-show="addProductVisible" @close-product="closeProduct" @fill-product="fillProduct"
                 ref="productCreate"></add-product>


  </div>
</template>

<script>
  import AddProduct from './addProduct.vue'
  import {
    productUnion,
    productList,
    productSecret,
    productDelete
  } from '@/api/factory/research/product'

  import {mapActions} from 'vuex'

  export default {
    computed: {},
    data() {
      return {
        addProductVisible: false,
        pagination: {
          name: '',
          start: 0,
          curPage: 1,
          limit: 8,
          total: 0,
        },
        products: []
      }
    },
    mounted: function () {
      this.loadProduct()
    },
    methods: {
      ...mapActions(["clearProductNames"]),
      fillProduct(product) {
        this.products.unshift(product)
        this.clearProductNames()
      },

      closeProduct() {
        this.addProductVisible = false
      },

      handleProductDetail(product) {
        this.$router.push({name: 'factory.research.product.detail', params: product})
      },
      handleCurrentChange(value) {
        this.pagination.curPage = value
        this.pagination.start = (value - 1) * this.pagination.limit
        productList(this.pagination).then(res => {
          this.products = res.data
        })
      },

      handleProductDelete(uuid, index) {
        this.$confirm('此操作将会删除产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          productDelete(uuid).then(res => {
            this.$message.success('删除成功')
            this.products.splice(index, 1)
            this.pagination.total -= 1
          })
        })

        //
      },
      loadSearchProduct() {
        this.pagination.start = 0
        this.pagination.curPage = 1
        this.loadProduct()
      },

      loadProduct() {
        let vue = this
        productUnion(this.pagination).then(res => {
          if (res !== null && res.code === 0) {
            vue.products = res.data.list || []
            vue.pagination.total = parseInt(res.data.total)
          }
        })
      },

      getProductSecret(product) {
        let vue = this
        productSecret(product.uuid).then(res => {
          vue.$alert(res.data, product.name, {
            confirmButtonText: this.$t('que_ding'),
          });
        })
      },


      handleProductCreate() {
        this.$refs.productCreate.showCreate()
        this.addProductVisible = true
      }
    },
    components: {
      AddProduct
    }
  }
</script>

<style lang="scss">

  .factory-device-product {
    padding: $padding $t-padding;
    display: flex;
    flex-direction: column;

    .factory-device-product-title {
      margin-bottom: $padding;

      .factory-device-product-title-filter {
        display: flex;
        justify-content: center;
        align-items: center;

        .label {
          display: inline-block;
          width: 5rem;
          font-size: .6rem;
          color: $f_sec_color;
          text-align: right;
        }
      }

      .el-input {
        .el-input__inner {
          height: 24px;
          line-height: 24px;
        }

        .el-input__icon {
          line-height: 24px;
        }
      }

      .btn-add {
        margin-left: $padding-5;
        color: $f_color;
        font-size: .6rem;
        padding: $padding-3;
        border-radius: .3rem;
        cursor: pointer;
      }

      .btn-add:hover {
        background-color: $bg_six_color;
        font-weight: $w1;
      }
    }

    .factory-device-products {
      flex-flow: row wrap;
      align-content: flex-start;

      .product-item {
        border: 1px solid $border_th_color;
        padding: $padding;
        border-radius: .2rem;
        font-size: .8rem;
        cursor: pointer;

        .content {
          display: inline-block;
          padding-left: $padding-5;
          color: $f_sec_color;
        }

        .info-item {
          margin-bottom: $padding-3;
        }

        .product {
          .product-name {
            color: $btn_color;
            font-weight: $w1;
          }

          .operate {
            .publish {
              margin-bottom: $padding-3;
              cursor: pointer;
            }

            .publish:hover {
              font-weight: $w1;
            }
          }
        }
      }
    }
  }

</style>
